import { useAppTranslation } from '@flowus/common/i18n';
import type { PageActivityEditDTO } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { InlinePage } from 'src/editor/editor/inline/inline-page';

import { PageSubject } from '../subject';
import { FeedTemplate } from './feed-template';

export const PageLockedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('views.page_feeds.action_locked')}
      subject={<PageSubject pageId={edit.navigableBlockId} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const PageUnlockedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('views.page_feeds.action_unlocked')}
      subject={<PageSubject pageId={edit.navigableBlockId} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const PageCreatedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('views.page_feeds.action_created')}
      subject={<PageSubject pageId={edit.navigableBlockId} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const PageDeletedFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('views.page_feeds.action_deleted')}
      subject={<InlinePage uuid={edit.navigableBlockId} interactable />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};

export const PageRestoredFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();
  return (
    <FeedTemplate
      edits={[edit]}
      action={t('views.page_feeds.action_restored')}
      subject={<PageSubject pageId={edit.navigableBlockId} />}
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};
